import { useEffect, useState } from 'react';

import { useAsyncFn } from 'react-use';

import { entityInbodyPinCodeService } from '../../../services/entityInbodyPinCodeService';

type UseInbodyPinProps = {
  entityId: number;
};

type UseInbodyPinReturn = {
  inbodyPin: string | null;
  isLoading: boolean;
};

export const useInbodyPin = ({ entityId }: UseInbodyPinProps): UseInbodyPinReturn => {
  const [inbodyPin, setInbodyPin] = useState<string | null>(null);

  const [state, getInbodyPin] = useAsyncFn(async () => {
    const inbodyPinData = await entityInbodyPinCodeService.getPinForPaymentResult(
      entityId,
      {
        ignoreErrorCodes: [404],
      },
    );

    setInbodyPin(inbodyPinData.pin);
  });

  useEffect(() => {
    getInbodyPin();
  }, [entityId]);

  return {
    inbodyPin,
    isLoading: state.loading,
  };
};
